export enum RouteKeys {
  List = '/leads',
  Details = '/leads/:id',
}
